import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import duration from 'dayjs/plugin/duration'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(duration)

function getPluralForm (count, unit) {
  return `${count} ${count === 1 ? unit : `${unit}s`}`
}

export function formatDate (date, emptyState = '--') {
  if (!date) {
    return emptyState
  }
  return dayjs(date).format('D MMM YYYY')
}

export function formatTime (date, emptyState = '--') {
  if (!date) {
    return emptyState
  }
  return dayjs(date).format('hh:mm A')
}

export function formatDateTime (date, emptyState = '--') {
  if (!date) {
    return emptyState
  }
  return dayjs(date).format('D MMM YYYY, HH:mm:ss')
}

export function formatFileDate (date, emptyState = '--') {
  if (!date) {
    return emptyState
  }
  return dayjs(date).format('DD/MM/YYYY HH:mm a')
}

export function formatLogDate (date, emptyState = '--') {
  if (!date) {
    return emptyState
  }
  return dayjs(date).format('DD/MM/YYYY h:mm a')
}

export function formatFromNow (date) {
  return dayjs(date).fromNow()
}

export function formatDuration (date, emptyState = '-') {
  if (!date) {
    return emptyState
  }
  const endTime = dayjs(date).add(2, 'h')
  const diff = dayjs.duration(dayjs(endTime).diff(new Date()))

  if (diff.asMilliseconds() < 0) {
    return 0
  }
  const [hours, minutes] = diff.format('H:mm').split(':').map((val) => parseInt(val))
  if (hours > 0) {
    return `${getPluralForm(hours, 'hour')} ${getPluralForm(minutes, 'minute')}`
  }
  return getPluralForm(minutes, 'minute')
}

export default formatDate
